RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.TrendsTooltipItem = Marionette.CompositeView.extend({

        getTemplate: function () {
            return '#widgetTrendsSingleMetricTooltipTemplate';
        },

        ui: {
            trendsTooltipItem: '.x-trends-tooltip-item'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        serializeData: function () {
            const me = this;

            if (me.model) {
                me.metric = me.model;
            }

            return {
                metric: me.metric
            };
        },

        templateHelpers: function () {
            const me = this;

            const helpers = App.utils.getSummaryTemplateHelpers(me, me.metric);

            if (me.metric.options.nameFcn) {
                helpers.title = me.metric.options.nameFcn();
            }

            return helpers;
        },

        onRender: function () {
            const me = this;

            const metric = me.model;
            const color = metric.getColor();
            if (color) {
                me.ui.trendsTooltipItem.css('color', color);
            }

            me.$('[data-toggle="popover"]').popover();
        }
    });

    widgets.TrendsTooltip = Marionette.CompositeView.extend({
        childView: widgets.TrendsTooltipItem,
        childViewContainer: '.row',

        childViewOptions: function () {
            const me = this;
            return {
                className: (me.collection.length > 1) ? 'trends-tooltip-col col-lg-6' : 'trends-tooltip-col col-lg-12'
            };
        },

        className: function () {
            const me = this;
            if (me.collection.length > 1) {
                return 'trends-tooltip';
            } else {
                return 'trends-tooltip-focus-company';
            }
        },

        getTemplate: function () {
            return '#widgetTrendsTooltipTemplate';
        },

        ui: {
            icon: '.fa'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        onRender: function () {
            const me = this;

            const metric = me.model || me.collection.first();
            const color = metric.getColor();
            if (color) {
                me.ui.icon.css('color', color);
            }

            me.$('[data-toggle="popover"]').popover();
        },

        attachHtml: function (collectionView, childView) {
            // NOTE we render stacked bars in reverse order, so we need to
            // reflect that in the labels by reversing them here
            collectionView._bufferedChildren.unshift(childView);
        }
    });
});
